import React from 'react';
import styled from 'styled-components';
import { Card, Spin, Tabs, theme } from 'components';
import { buildCssProps } from 'utils';

export const StyledBodyPane = styled.div<{ $blur?: boolean }>`
  background: white;
  border: 1px solid #f0f0f0;
  border-radius: 2px;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  padding: 36px;
  ${({ $blur }) =>
    buildCssProps([
      ['filter', $blur && `blur(${theme.pageBlurRadius})`],
      ['pointer-events', $blur && 'none'],
    ])}
`;

export const StyledPageContent = styled.div`
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
`;

export const StyledIconWrapper = styled.div<{
  $width?: number;
  $height?: number;
}>`
  ${({ $width }) => ($width ? `width: ${$width}px;` : `width: 32px;`)}
  ${({ $height }) => ($height ? `height: ${$height}px;` : `height: 32px;`)}
  border-radius: 50%;
  background-color: ${theme.blue1};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledActivateSection = styled.div<{
  $border?: boolean;
  $sm?: boolean;
}>`
  ${({ $border }) => $border && `border: 1px solid ${theme.gray4};`}
  width: 100%;
  padding: 24px;
  display: flex;
  align-items: center;
  ${({ $sm }) => $sm && `flex-direction: column`}
`;

// this is a customizable container where we can specify the padding and margin and flex behaviour by passing props to it.
// This can be moved to components folder in the future so it can be used in all the App components
export const StyledBox = styled.div<{
  $m?: number;
  $p?: number;
  $mb?: number;
  $mt?: number;
  $mr?: number;
  $ml?: number;
  $my?: number;
  $mx?: number;
  $pb?: number;
  $pt?: number;
  $pr?: number;
  $pl?: number;
  $py?: number;
  $px?: number;
  $justify?:
    | 'center'
    | 'flex-start'
    | 'flex-end'
    | 'space-between'
    | 'space-around'
    | 'space-evenly';
  $alignItems?: 'stretch' | 'flex-start' | 'flex-end' | 'center' | 'baseline';
  $alignContent?:
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'space-between'
    | 'space-around'
    | 'space-evenly'
    | 'stretch';
  $flexDirection?: 'row' | 'row-reverse' | 'column' | 'column-reverse';
  $flexWrap?: 'no-wrap' | 'wrapt' | 'wrap-reverse';
}>`
  ${({ $m, $mb, $mt, $mr, $ml, $mx, $my }) =>
    `margin:${$mt || $my || $m || 0}rem ${$mr || $mx || $m || 0}rem ${
      $mb || $my || $m || 0
    }rem ${$ml || $mx || $m || 0}rem;`}
  ${({ $p, $pb, $pt, $pr, $pl, $px, $py }) =>
    `padding:${$pt || $py || $p || 0}rem ${$pr || $px || $p || 0}rem ${
      $pb || $py || $p || 0
    }rem ${$pl || $px || $p || 0}rem;`}
  display: flex;
  ${({ $justify }) => $justify && `justify-content:${$justify};`}
  ${({ $alignItems }) => $alignItems && `align-items:${$alignItems};`}
  ${({ $alignContent }) => $alignContent && `align-content:${$alignContent};`}
  ${({ $flexDirection }) =>
    $flexDirection && `flex-direction:${$flexDirection};`}
  ${({ $flexWrap }) => $flexWrap && `flex-wrap:${$flexWrap};`}
`;

export const StyledServicePhoneContainer = styled(StyledBox)`
  width: 100%;
  border: 1px solid ${theme.gray4};
  width: max(480px, 40%);
`;

const StyledSpinnerContainer = styled(StyledBox)`
  height: 20vh;
`;

export const StyledLoading = (
  <StyledSpinnerContainer $justify="center" $alignItems="center" $p={3.6}>
    <Spin size="large" />
  </StyledSpinnerContainer>
);

export const StyledTabs = styled(Tabs)`
  background-color: white;
  ${StyledBodyPane}, ${Card} {
    border: unset;
  }
  .ant-tabs-nav {
    padding-left: 12px;
    margin-bottom: 0;
  }
  .ant-tabs-tab-active > .ant-tabs-tab-btn {
    color: ${theme.blue6};
  }
`;

export const StyledBlurredWrapper = styled.span;
